export const cropLabel = (crop, lang) => lang === 'it' ? crop.label_it || crop.label_en : crop.label_en;
export const normalizeSearch = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
export const cropMatches = (crop, query) => [crop.crop_display_group?.label_it, crop.crop_display_group?.label_en, crop.label_it, crop.label_en, crop.fao_botanical_original, crop.scientific_name_verified, crop.crop_id, ...(crop.search_terms_it || [])].some(part => normalizeSearch(part).includes(normalizeSearch(query)));


// Explicit reviewed display families; botanical identity never merges production uses.
export function groupCropRows(rows, lang) {
 const groups = new Map();
 for (const row of rows) {
  const family = row.crop_display_group;
  const key = family ? `family:${family.key}` : row.crop_id;
  if (!groups.has(key)) groups.set(key, { key, label: family ? (lang === 'it' ? family.label_it : family.label_en) : cropLabel(row, lang), rows: [] });
  groups.get(key).rows.push(row);
 }
 return [...groups.values()].sort((a,b) => a.label.localeCompare(b.label, lang));
}
